
/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";
import VPagination from "@hennge/vue3-pagination";
import labValidationRule from "../labValidationRule/labValidationRule.vue";
import labTestVersion from "../labTestVersion/labTestVersion.vue";
import Multiselect from "@vueform/multiselect";
import jwt_decode from "jwt-decode";
import labApproveReject from "../labApproveReject/labApproveReject.vue";

export default {
  name: "setTestRanges",
  components: {
    customModal,
    VPagination,
    labValidationRule,
    labTestVersion,
    Multiselect,
    labApproveReject
  },
  props: {
     id: {
      type: String,
      default: "",
    },
    showSetRange: {
      type: Boolean,
      default: false,
    },
    labCode: {
      type: String,
      default: "",
    },
    testCode: {
      type: String,
      default: "",
    },
    unitselected: {
      type: String,
      default: "",
    },
    cdiscVariable: {
      type: String,
      default: "",
    },
  
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      token: "",
      showLoading: false,
      currentApprovalStatus: "",
      approvedStatus: "",
      labList: [],
      totalItems: 0,
      gender: "",
      ageMin: null,
      ageMax: null,
      minRange: null,
      maxRange: null,
      rangeSeverity: "",
      unit: "",
      showValidationRule:false,
      selectedVersion: "",
      showAddRangeVersionModal: false,
      showStatusModal:false,
      effectiveDate: new Date().toISOString(),
      isActive: true,
      studyId: "",
      versionList: [],
      SortOrder: 0,
      SortProperty: "",
      currentPage: 1,
      localLabCode: "",
      localTestCode: "",
      ageErrors: [false, false, false],
      rangeErrors: [false, false],
      isEditing: false,
      versionNo: "",
      isVersionLocked: false,
      ageErrors: [false, false, false],
      rangeErrors: [false, false, false],
      genderError: false,
      versionNoError: false,
      showLabVersionPopup:false,
      unitError: false,
      isVersionLocked: false,
       referenceId: "",
      isVersionPrefilled: false,
      isUnitPrefilled: false,
      editingId: null,
      selectedLabCode: "",
      hasLabReferences: false,
      selectedTestCode: "",
      selectedRuleName: "",
      selectedRuleCode: "",
      validationForm: {
        gender: "",
        ageMin: null,
        ageMax: null
      },

      user: {},
      documentApprovalModal: false,
      roleList: [],
      designationList: [],
      userList: [],
      userobject: {},
      isSelectedUser: [],
      isRequired: [],
      isDisabled: [],
      loadingSingleSave: [],
      loadingSaveModalBtn: false,
      selectedDueDate: "",
      existingApprovers: [],
      showApproveRejectPopup: false,
      showActivateBtn: false,
      showApproveBtn: false,
      loading: false,
      approvals: {
        studyId: "",
        version: "",
        actionType: "approval",
        approveList: [],
      },
    };
  },
  computed: {
  minRangeValue: {
    get() {
      return this.minRange;
    },
    set(value) {
      // Handle empty string conversion to null
      this.minRange = value === '' ? null : Number(value);
    }
  },
  maxRangeValue: {
    get() {
      return this.maxRange;
    },
    set(value) {
      this.maxRange = value === '' ? null : Number(value);
    }
  }
},

  async mounted() {
    
     await this.setBtnVisibility();
      
    this.token = store.getters.getIdToken;
    this.studyId = store.getters.getStudyIs;
    this.localLabCode = this.labCode;
    this.localTestCode = this.testCode;
    this.unit = this.unitselected;
    this.referenceId = this.id;
    console.log("unittselected", this.unitselected);

    this.getLabReferenceVersion();
    await this.getVersionList();
    await this.sortVersions();
    this.unit = this.unitselected;
    this.isUnitPrefilled = !!this.unit;
    
    
    if (this.versionNo && this.versionNo.trim() !== "") {
      this.isVersionPrefilled = true;
    }
    
    await this.getUserDetails();
    await this.setBtnVisibility();
  },

  methods: {
    closeRange() {
      this.showAddRangeVersionModal = false;
      this.resetForm();
    },
    closeStatus(){
      this.showStatusModal = false;


    },
    
    closeSetRange() {
      this.$emit("closeModal");
    },


    async onVersionChange() {
  try {
    console.log("Version changed:", this.selectedVersion);
    this.versionNo = this.selectedVersion;

    await this.listLabTestRanges();
    

    const lab = this.localLabCode || this.labCode;
    const test = this.localTestCode || this.testCode;
    const study = this.studyId;

    const response = await axios.get(
      `${this.baseurl}/management/labreferencerange/getlabreferenceversionbyid`,
      {
        params: {
          labcode: lab,
          testcode: test,
          studyid: study,
        },
        headers: {
          Authorization: `Bearer ${this.token}`,
          "Content-Type": "application/json",
        },
      }
    );

    const data = response.data || {};
    console.log("Version changed - new data:", data);

    const selectedVersionObj = Array.isArray(data.versions)
      ? data.versions.find(v => v.version === this.selectedVersion)
      : null;

    if (selectedVersionObj) {

      if (selectedVersionObj.approval && selectedVersionObj.approval.length > 0) {
        const allApproved = selectedVersionObj.approval.every(approver => 
          approver.approvedStatus === 'Approved'
        );
        
        const anyRejected = selectedVersionObj.approval.some(approver => 
          approver.approvedStatus === 'Rejected'
        );
        
        const anyPending = selectedVersionObj.approval.some(approver => 
          approver.approvedStatus === 'Pending'
        );

        if (anyRejected) {
          this.approvedStatus = "Rejected";
        } else if (allApproved) {
          this.approvedStatus = "Approved";
        } else if (anyPending) {
          this.approvedStatus = "Pending";
        } else {
          this.approvedStatus = selectedVersionObj.approval[0]?.approvedStatus || "";
        }
      } else {

        this.approvedStatus = "";
      }
      
      this.versionNo = selectedVersionObj.version || "";
      this.effectiveDate = selectedVersionObj.createdAt || this.effectiveDate;
    } else {
      console.warn("No matching version found for:", this.selectedVersion);
      this.approvedStatus = "";
    }
    
    await this.setBtnVisibility();
    console.log("Version change completed - Approval Status:", this.approvedStatus);
    
  } catch (err) {
    console.error("Error in onVersionChange:", err);
  }
},

async getLabReferenceVersion() {
  try {
    const lab = this.localLabCode || this.labCode;
    const test = this.localTestCode || this.testCode;
    const study = this.studyId;

    const response = await axios.get(
      `${this.baseurl}/management/labreferencerange/getlabreferenceversionbyid`,
      {
        params: {
          labcode: lab,
          testcode: test,
          studyid: study,
        },
        headers: {
          Authorization: `Bearer ${this.token}`,
          "Content-Type": "application/json",
        },
      }
    );

    const data = response.data || {};
    console.log("getLabReferenceVersion response:", { currentVersion: data.currentVersion, versions: data.versions });

    const validVersions = Array.isArray(data.versions)
      ? data.versions.filter(v => v.isActive !== false).map(v => v.version)
      : [];
    if (!this.selectedVersion || !validVersions.includes(this.selectedVersion)) {
      this.selectedVersion = data.currentVersion || validVersions[0] || "";
      this.versionNo = this.selectedVersion || "";
    }
    if (this.selectedVersion) {
      await this.listLabTestRanges();
    } else {
      console.warn("No valid versions found, skipping listLabTestRanges");
      this.labList = [];
      this.approvedStatus = "";
      this.versionNo = "";
    }

    const selectedVersionObj = Array.isArray(data.versions)
      ? data.versions.find(v => v.version === this.selectedVersion)
      : null;

    if (selectedVersionObj) {
      // mark disabled users if any
      if (Array.isArray(selectedVersionObj.approval)) {
        selectedVersionObj.approval.forEach(approver => {
          this.userList.forEach((user, index) => {
            if (user.email === approver.approvedByEmail) {
              this.isDisabled[index] = true;
            }
          });
        });
      }

      this.approversList = Array.isArray(selectedVersionObj.approval)
        ? selectedVersionObj.approval.map(a => ({
            approvedByUsername: a.approvedByUsername || a.approvedByName || "-",
            approvedStatus: a.approvedStatus || a.approvedStatus || "Pending",
            approvedByEmail: a.approvedByEmail || a.approvedBy || ""
          }))
        : [];

     
      this.approvedStatus = this.getVersionApprovalStatus(selectedVersionObj);
      this.versionNo = selectedVersionObj.version || this.versionNo;
      this.unit = selectedVersionObj.unit || this.unitselected || this.unit || "";
      this.effectiveDate = selectedVersionObj.createdAt || this.effectiveDate;

      console.log("Set approvedStatus:", this.approvedStatus, "unit:", this.unit, "approversCount:", this.approversList.length);
    } else {
      console.warn("No matching version found for:", this.selectedVersion);
      this.approvedStatus = "";
      this.versionNo = this.selectedVersion || "";
      this.unit = this.unitselected || this.unit || "";
      this.approversList = [];
    }
    try {
      await this.setBtnVisibility();
    } catch (e) {
      console.warn("setBtnVisibility failed:", e);
    }
  } catch (err) {
    console.error("Error fetching lab reference version:", err);
    this.labList = [];
    this.approvedStatus = "";
    this.versionNo = "";
    this.unit = this.unitselected || this.unit || "";
    this.approversList = [];
    alert("Failed to fetch lab reference version details");
  }
},
getVersionApprovalStatus(versionData) {
  if (!versionData || !versionData.approval || !Array.isArray(versionData.approval)) {
    return "";
  }
  
  const approvals = versionData.approval;
  
 
  if (approvals.length === 0) {
    return "";
  }

  const allApproved = approvals.every(approver => 
    approver.approvedStatus === 'Approved'
  );
  
  const anyRejected = approvals.some(approver => 
    approver.approvedStatus === 'Rejected'
  );
  
  const anyPending = approvals.some(approver => 
    approver.approvedStatus === 'Pending'
  );

  if (anyRejected) {
    return "Rejected";
  } else if (allApproved) {
    return "Approved";
  } else if (anyPending) {
    return "Pending";
  } else {
    return approvals[0]?.approvedStatus || "";
  }
},



    
async listLabTestRanges() {
  this.showLoading = true;
  const lab = this.localLabCode || this.labCode;
  const test = this.localTestCode || this.testCode;

  try {
    const response = await axios.get(
      `${this.baseurl}/management/labreferencerange/labreferencerangelist?LabCode=${lab}&TestCode=${test}&StudyId=${this.studyId}&VersionNo=${this.selectedVersion}&Gender=${this.gender}&pageindex=${this.currentPage}&pagesize=10&SortProperty=&SortOrder=0`,
      {
        headers: {
          Authorization: `Bearer ${this.token}`,
          "Content-Type": "application/json",
        },
      }
    );

    const data = response.data || {};
    this.labList = Array.isArray(data.results) ? data.results : [];
    this.totalItems = Math.ceil((data.totalCount || 0) / 10);

    this.hasLabReferences = this.labList.length > 0;
    console.log("Lab references count:", this.labList.length);
    console.log("hasLabReferences:", this.hasLabReferences);

    if (this.labList.length > 0) {
      this.unit = this.labList[0].unit || this.unitselected;
      if (!this.referenceId && this.labList[0].id) {
        this.referenceId = this.labList[0].id;
        console.log("Set referenceId from API response:", this.referenceId);
      }
      if (data.results && data.results.length > 0) {
        this.approvedStatus = data.results[0].approvedStatus || "";
      }
    } else {
      console.warn("No lab test ranges found for the given parameters");
      this.unit = this.unitselected; 
      this.approvedStatus = "";
    }
  } catch (err) {
    console.error("Error fetching lab test ranges:", err);
    this.hasLabReferences = false;
    this.labList = [];
    this.approvedStatus = "";
  } finally {
    this.showLoading = false;
  }
}
,

    
async getVersionList() {
  try {
    console.log("getVersionList called with:", {
      LabCode: this.localLabCode || this.labCode,
      TestCode: this.localTestCode || this.testCode,
      StudyId: this.studyId,
    });

    const lab = this.localLabCode || this.labCode;
    const test = this.localTestCode || this.testCode;

    const versionResponse = await axios.get(
      `${this.baseurl}/management/labreferencerange/getlabreferenceversionbyid`,
      {
        params: {
          labcode: lab,
          testcode: test,
          studyid: this.studyId,
        },
        headers: {
          Authorization: `Bearer ${this.token}`,
          "Content-Type": "application/json",
        },
      }
    );

    const versionData = versionResponse.data || {};
    console.log("Version API response:", versionData);

    let allVersions = [];
    if (Array.isArray(versionData.versions)) {
      allVersions = versionData.versions
        .filter(v => v.version && v.version.trim() && v.isActive !== false)
        .map(v => v.version);
    }
    const rangesResponse = await axios.get(
      `${this.baseurl}/management/labreferencerange/labreferencerangelist?LabCode=${lab}&TestCode=${test}&StudyId=${this.studyId}&pageindex=1&pagesize=1000`,
      {
        headers: {
          Authorization: `Bearer ${this.token}`,
          "Content-Type": "application/json",
        },
      }
    );

    const rangesData = rangesResponse.data || {};
    const allResults = Array.isArray(rangesData.results) ? rangesData.results : [];

    const rangesVersions = new Set();
    allResults.forEach(item => {
      if (item.versionNo?.trim()) {
        rangesVersions.add(item.versionNo);
      }
    });
    const combinedVersions = [...new Set([...allVersions, ...Array.from(rangesVersions)])];
    

    this.versionList = combinedVersions.sort((a, b) => {
      const na = parseFloat(a);
      const nb = parseFloat(b);
      if (!isNaN(na) && !isNaN(nb)) return nb - na;
      return b.localeCompare(a, undefined, { numeric: true, sensitivity: "base" });
    });

    console.log("Final versionList:", this.versionList);

    if (this.versionList.length > 0) {
      if (!this.selectedVersion || !this.versionList.includes(this.selectedVersion)) {
        this.selectedVersion = this.versionList[0];
        this.versionNo = this.versionList[0];
        console.log("Selected latest version:", this.versionList[0]);
        await this.listLabTestRanges();
      }
    } else {
      console.log("No versions found, clearing selectedVersion");
      this.selectedVersion = "";
      this.versionNo = "";
      this.labList = [];
      this.approvedStatus = "";
      this.hasLabReferences = false;
    }

    await this.setBtnVisibility();
  } catch (err) {
    console.error("Error in getVersionList:", err.response?.data || err.message);
    this.versionList = [];
    this.selectedVersion = "";
    this.versionNo = "";
    this.labList = [];
    this.approvedStatus = "";
    this.$toast.error(this.$t("navigations.failed to load versions"));
    await this.setBtnVisibility();
  }
},
    
    async sortVersions(results) {
      const versionSet = new Set(
        results.map(item => item.versionNo?.trim()).filter(v => v)
      );

      const sorted = Array.from(versionSet).sort((a, b) => {
        const numA = parseFloat(a);
        const numB = parseFloat(b);
        if (!isNaN(numA) && !isNaN(numB)) {
          return numB - numA;
        }
        return b.localeCompare(a, undefined, { numeric: true, sensitivity: "base" });
      });

      return sorted;
    },

    async getLabMaster() {
      await this.listLabTestRanges();
    },
    
    showAddRangeModal() {
      this.resetForm();
      if (this.versionList && this.versionList.length > 0) {
        this.isVersionLocked = true;
      } else {
        this.isVersionLocked = false;
      }
      if (!this.unit && this.unitselected) {
    this.unit = this.unitselected;
  }
      this.showAddRangeVersionModal = true;
    },
    
    async saveRanges() {
      this.validate();
      if (this.ageErrors.includes(true) || this.rangeErrors.includes(true) || 
        this.genderError || this.versionNoError || this.unitError) {
        return; 
      }

      const idtoken = store.getters.getIdToken;

      const payload = {
        ...(this.isEditing && this.editingId ? { Id: this.editingId } : {}),
        LabCode: this.localLabCode,
        TestCode: this.localTestCode,
       CdiscVariable: this.cdiscVariable || "", 
        Gender: this.gender,
        AgeMin: this.ageMin !== null && this.ageMin !== undefined ? this.ageMin : 0,
        AgeMax: this.ageMax !== null && this.ageMax !== undefined ? this.ageMax : 0,
        Unit: this.unit,
        VersionNo: this.versionNo,
        EffectiveDate: this.effectiveDate,
        IsActive: this.isActive,
        StudyId: this.studyId,
        AccountId: store.getters.getAccountId,
        CreatedUserId: store.getters.getUserId,
        CreatedUserEmail: store.getters.getUserEmail,
        CreatedAt: new Date().toISOString(),
        LastModifiedUserId: store.getters.getUserId,
        LastModifiedUserEmail: store.getters.getUserEmail,
        LastModifiedAt: new Date().toISOString(),
        Ranges: [
          {
            ValueMin: this.minRange,
            ValueMax: this.maxRange,
            Qualitative: this.rangeSeverity,
            ReferenceRange: `${this.minRange} - ${this.maxRange}`,
          },
        ],
      };

      try {
        if (this.isEditing && this.editingId) {
          await axios.put(
            `${this.baseurl}/management/labreferencerange/update`,
            payload,
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          );
          alert(this.$t("navigations.lab reference updated successfully"));
          this.isVersionLocked = true;
          this.listLabTestRanges();
          this.$emit("showSetVersion", true);
           this.showAddRangeVersionModal= false;
          this.getLabReferenceVersion();
        } else {
          await axios.post(
            `${this.baseurl}/management/labreferencerange/create`,
            payload,
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          );
          alert(this.$t("navigations.lab reference created successfully"));
          this.isVersionLocked = true;
          
      await this.getVersionList();
      await this.listLabTestRanges();
          this.$emit("showSetVersion", true);
        }

        this.resetForm();
        await this.listLabTestRanges();
      } catch (err) {
        console.error(err);
        alert(err.response?.data?.detail || "Save operation failed");
      }
    },
    
    validateGender() {
      this.genderError = !this.gender;
      return !this.genderError;
    },
    async editlabtest(id) {
  this.showAddRangeVersionModal = true;
  try {
    const response = await axios.get(
      `${this.baseurl}/management/labreferencerange/getbyid?id=${id}`,
      {
        headers: {
          Authorization: `Bearer ${this.token}`,
          "Content-Type": "application/json",
        },
      }
    );

    const record = response.data;
    if (record) {
      this.isEditing = true;
      this.editingId = record.id;
      this.gender = record.gender;
      this.ageMin = record.ageMin;
      this.ageMax = record.ageMax;

      const ranges = record.ranges || [];
      const firstRange = ranges[0] || {};

      this.minRange = firstRange.valueMin !== undefined ? firstRange.valueMin : null;
      this.maxRange = firstRange.valueMax !== undefined ? firstRange.valueMax : null;
      
      this.rangeSeverity = firstRange.qualitative || "";
      this.unit = record.unit;
      this.versionNo = record.versionNo;
      this.effectiveDate = record.effectiveDate;
      this.isActive = record.isActive;
      this.studyId = record.studyId;
      this.localLabCode = record.labCode;
      this.localTestCode = record.testCode;
      this.isUnitPrefilled = !!record.unit;
      this.isVersionPrefilled = !!record.versionNo;
      this.isVersionLocked = true;
      if (!this.showSetRange) this.$emit("openModal");
    }
  } catch (err) {
    console.error("Error fetching record by ID:", err);
    alert("Failed to load record for editing");
  }
},

    // async editlabtest(id) {
    //   this.showAddRangeVersionModal = true;
    //   try {
    //     const response = await axios.get(
    //       `${this.baseurl}/management/labreferencerange/getbyid?id=${id}`,
    //       {
    //         headers: {
    //           Authorization: `Bearer ${this.token}`,
    //           "Content-Type": "application/json",
    //         },
    //       }
    //     );

    //     const record = response.data;
    //     if (record) {
    //       this.isEditing = true;
    //       this.editingId = record.id;
    //       this.gender = record.gender;
    //       this.ageMin = record.ageMin;
    //       this.ageMax = record.ageMax;
    //       //   this.minRange = record.ranges?.[0]?.valueMin || null;
    //       // this.maxRange = record.ranges?.[0]?.valueMax || null;
    //        this.minRange = record.ranges?.[0]?.valueMin ?? null;
    //   this.maxRange = record.ranges?.[0]?.valueMax ?? null;
    //       this.rangeSeverity = record.ranges?.[0]?.qualitative || "";
    //       this.unit = record.unit;
    //       this.versionNo = record.versionNo;
    //       this.effectiveDate = record.effectiveDate;
    //       this.isActive = record.isActive;
    //       this.studyId = record.studyId;
    //       this.localLabCode = record.labCode;
    //       this.localTestCode = record.testCode;
    //       this.isUnitPrefilled = !!record.unit;
    //       this.isVersionPrefilled = !!record.versionNo;
    //       this.isVersionLocked = true;
    //       if (!this.showSetRange) this.$emit("openModal");
    //     }
    //   } catch (err) {
    //     console.error("Error fetching record by ID:", err);
    //     alert("Failed to load record for editing");
    //   }
    // },
    async deleteLabs(id) {
      if (!confirm(this.$t("navigations.are you sure you want to delete this lab reference range?"))) return;

      try {
        const response = await axios.delete(
          `${this.baseurl}/management/labreferencerange/deletebyid/?LabReferenceRangeID=${id}`,
          {
            headers: {
              Authorization: "Bearer " + this.token,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200 || response.status === 204) {
          alert(this.$t("navigations.lab reference range deleted successfully"));

          const lab = this.localLabCode || this.labCode;
          const test = this.localTestCode || this.testCode;
          const study = this.studyId;
          const versionToCheck = this.selectedVersion || this.versionNo;

          try {
            if (versionToCheck) {
              const checkResp = await axios.get(
                `${this.baseurl}/management/labreferencerange/labreferencerangelist`,
                {
                  params: {
                    LabCode: lab,
                    TestCode: test,
                    StudyId: study,
                    VersionNo: versionToCheck,
                    pageindex: 1,
                    pagesize: 1
                  },
                  headers: {
                    Authorization: `Bearer ${this.token}`,
                    "Content-Type": "application/json",
                  },
                }
              );

              const remaining = Array.isArray(checkResp.data?.results) ? checkResp.data.results.length : 0;

              if (remaining === 0) {
              
                this.versionList = (this.versionList || []).filter(v => v !== versionToCheck);

                if (this.versionList.length > 0) {
                  this.selectedVersion = this.versionList[0];
                  this.versionNo = this.versionList[0];
                } else {
                  this.selectedVersion = "";
                  this.versionNo = "";
                }
              } else {
 
                this.selectedVersion = versionToCheck;
                this.versionNo = versionToCheck;
              }
            } else {

              await this.getVersionList();
            }
          } catch (checkErr) {
            console.warn("Failed to verify remaining references for version:", checkErr);

            await this.getVersionList();
          }

          await this.listLabTestRanges();

          this.resetForm();
          await this.setBtnVisibility();
          await this.getLabReferenceVersion();
        } else {
          console.warn("Unexpected response:", response);
          alert("Delete may not have completed successfully");
        }
      } catch (err) {
        console.error("Delete error:", err);
        alert(err.response?.data?.detail || "Delete failed");
      }
    },

    formatDate(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      return date.toLocaleDateString();
    },

    validate() {
      this.ageErrors = [false, false, false];
      this.rangeErrors = [false, false, false];
      this.genderError = false;
      this.versionNoError = false;
      this.unitError = false;

      let isValid = true;

      if (this.ageMin == null || this.ageMin === "" || isNaN(this.ageMin) || this.ageMin < 0) {
        this.ageErrors[0] = true;
        isValid = false;
      }
      if (this.ageMax == null || this.ageMax === "" || isNaN(this.ageMax) || this.ageMax < 0) {
        this.ageErrors[1] = true;
        isValid = false;
      }
      if (this.ageMin != null && this.ageMax != null && parseFloat(this.ageMax) <= parseFloat(this.ageMin)) {
        this.ageErrors[2] = true;
        isValid = false;
      }

      if (this.minRange == null || this.minRange === "" || isNaN(this.minRange)) {
        this.rangeErrors[0] = true;
        isValid = false;
      }
      if (this.maxRange == null || this.maxRange === "" || isNaN(this.maxRange)) {
        this.rangeErrors[1] = true;
        isValid = false;
      }
      if (this.minRange != null && this.maxRange != null && parseFloat(this.maxRange) <= parseFloat(this.minRange)) {
        this.rangeErrors[2] = true;
        isValid = false;
      }
      if (!this.rangeSeverity) {
        this.rangeErrors[3] = true;
        isValid = false;
      }

      if (!this.gender) {
        this.genderError = true;
        isValid = false;
      }
      if (!this.versionNo) {
        this.versionNoError = true;
        isValid = false;
      }
      if (!this.unit) {
        this.unitError = true;
        isValid = false;
      }

      return isValid;
    },
    
    validateAgeMin() {
      if (this.ageMin == null || this.ageMin === "" || isNaN(this.ageMin) || this.ageMin < 0) {
        this.ageErrors[0] = true;
        return false;
      }
      
      this.ageErrors[0] = false;
      
      if (this.ageMax != null && this.ageMax !== "" && !isNaN(this.ageMax)) {
        if (parseFloat(this.ageMax) <= parseFloat(this.ageMin)) {
          this.ageErrors[2] = true;
        } else {
          this.ageErrors[2] = false;
        }
      }
      
      return true;
    },

    validateAgeMax() {
      if (this.ageMax == null || this.ageMax === "" || isNaN(this.ageMax) || this.ageMax < 0) {
        this.ageErrors[1] = true;
        return false;
      }
      
      this.ageErrors[1] = false;
      
      if (this.ageMin != null && this.ageMin !== "" && !isNaN(this.ageMin)) {
        if (parseFloat(this.ageMax) <= parseFloat(this.ageMin)) {
          this.ageErrors[2] = true;
        } else {
          this.ageErrors[2] = false;
        }
      }
      
      return true;
    },
    validateMinRange() {
  // Explicit check for null/undefined/empty string
  if (this.minRange === null || 
      this.minRange === undefined || 
      this.minRange === "" || 
      isNaN(this.minRange) || 
      this.minRange < 0) {
    this.rangeErrors[0] = true;
    return false;
  }
  
  this.rangeErrors[0] = false;

  if (this.maxRange !== null && 
      this.maxRange !== undefined && 
      this.maxRange !== "" && 
      !isNaN(this.maxRange)) {
    if (parseFloat(this.maxRange) <= parseFloat(this.minRange)) {
      this.rangeErrors[2] = true;
    } else {
      this.rangeErrors[2] = false;
    }
  }
  
  return true;
},

validateMaxRange() {
  if (this.maxRange === null || 
      this.maxRange === undefined || 
      this.maxRange === "" || 
      isNaN(this.maxRange)) {
    this.rangeErrors[1] = true;
    return false;
  }
  
  this.rangeErrors[1] = false;
  

  if (this.minRange !== null && 
      this.minRange !== undefined && 
      this.minRange !== "" && 
      !isNaN(this.minRange)) {
    if (parseFloat(this.maxRange) <= parseFloat(this.minRange)) {
      this.rangeErrors[2] = true;
    } else {
      this.rangeErrors[2] = false;
    }
  }
  
  return true;
},

    // validateMinRange() {
    //   if (this.minRange == null || this.minRange === "" || isNaN(this.minRange) || this.minRange < 0) {
    //     this.rangeErrors[1] = true;
    //     return false;
    //   }
      
    //   this.rangeErrors[0] = false;
      
    //   if (this.maxRange != null && this.maxRange !== "" && !isNaN(this.maxRange)) {
    //     if (parseFloat(this.maxRange) <= parseFloat(this.minRange)) {
    //       this.rangeErrors[2] = true;
    //     } else {
    //       this.rangeErrors[2] = false;
    //     }
    //   }
      
    //   return true;
    // },

    // validateMaxRange() {
    //   if (this.maxRange == null || this.maxRange === "" || isNaN(this.maxRange)) {
    //     this.rangeErrors[1] = true;
    //     return false;
    //   }
      
    //   this.rangeErrors[1] = false;
      
    //   if (this.minRange != null && this.minRange !== "" && !isNaN(this.minRange)) {
    //     if (parseFloat(this.maxRange) <= parseFloat(this.minRange)) {
    //       this.rangeErrors[2] = true;
    //     } else {
    //       this.rangeErrors[2] = false;
    //     }
    //   }
      
    //   return true;
    // },

    resetForm() {
      this.gender = "";
      this.ageMin = null;
      this.ageMax = null;
      this.minRange = null;
      this.maxRange = null;
      this.rangeSeverity = "";
      this.effectiveDate = new Date().toISOString();
      this.isActive = true;
      this.isEditing = false;
      this.editingId = null;
      this.ageErrors = [false, false, false];
      this.rangeErrors = [false, false, false];
      this.genderError = false;
      this.versionNoError = false;
      this.unitError = false;
    },
    
    async openValidationModal(item) {
      try {
        const response = await axios.get(
          `${this.baseurl}/management/labreferencerange/getbyid?id=${item}`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
            },
          }
        );

        const record = response.data;
        console.log("response", record);
        
        this.selectedLabCode = this.labCode;
        this.selectedTestCode = this.testCode;
        this.selectedRuleName = record.ruleName || "";
        this.selectedRuleCode = record.ruleCode || "";
        this.referenceRangeId = record.id || item;
        this.validationForm.gender = record.gender || "";
        this.validationForm.ageMin = record.ageMin !== null && record.ageMin !== undefined ? record.ageMin : null;
        this.validationForm.ageMax = record.ageMax !== null && record.ageMax !== undefined ? record.ageMax : null;
        
        this.showValidationRule = true;
      } catch (err) {
        console.error("Error fetching record for validation:", err);
        alert("Failed to load record for validation rule");
      }
    },
    
    closeValidation() {
      this.showValidationRule = false;
    },

    openVersionModal() {
      this.selectedLabCode = this.labCode;
      this.selectedTestCode = this.testCode;
      const selectedRecord = this.labList.find(l => l.versionNo === this.selectedVersion);
      this.selectedVersion = selectedRecord?.versionNo || "";
      
      this.showLabVersionPopup = true;
      
    },
    closeVersionModal(){
      this.showLabVersionPopup = false;
       this.getVersionList(); 
    },

    async refreshLabTestList(newarray) {
      let newVersion = newarray[0];
     
  console.log("refreshLabTestList called with newVersion:", newarray);
  try {

    let retries = 3;
    let versionFound = false;
    
    while (retries > 0 && !versionFound) {
      await this.getVersionList();
      console.log("versionList after getVersionList:", this.versionList);
      
      if (newVersion && this.versionList.includes(newVersion)) {
        versionFound = true;
        console.log("New version found in versionList:", newVersion);
      } else {
        console.warn(`New version ${newVersion} not found in versionList, retrying (${retries} attempts left)`);
        retries--;

        await new Promise(resolve => setTimeout(resolve, 1000));
      }
    }

    if (newVersion && !this.versionList.includes(newVersion)) {
      console.warn(`New version ${newVersion} not returned by API, adding manually`);
      this.versionList.unshift(newVersion);
      this.versionList.sort((a, b) => {
        const na = parseFloat(a);
        const nb = parseFloat(b);
        if (!isNaN(na) && !isNaN(nb)) return nb - na;
        return b.localeCompare(a, undefined, { numeric: true, sensitivity: "base" });
      });
    }

    if (newVersion && this.versionList.includes(newVersion)) {
      this.selectedVersion = newVersion;
      this.versionNo = newVersion;
      console.log("Selected new version:", newVersion);
    } else if (this.versionList.length > 0) {
      this.selectedVersion = this.versionList[0];
      this.versionNo = this.versionList[0];
      console.log("Selected latest version:", this.versionList[0]);
    } else {
      this.selectedVersion = "";
      this.versionNo = "";
      console.log("No versions available");
    }

    await this.listLabTestRanges();
    console.log("Refresh completed. versionList:", this.versionList, "selectedVersion:", this.selectedVersion);

    this.$forceUpdate();
  } catch (err) {
    console.error("Error in refreshLabTestList:", err.response?.data || err.message);
    this.$toast.error(this.$t("navigations.failed to refresh lab test list"));
  }
  this.unit = newarray[1];
},

    handleShowSetVersion(value) {
      if (value) {
        this.refreshLabTestList();
      }
    },

    async getUserDetails() {
      this.user = jwt_decode(store.getters.getIdToken);
    },
async viewAssigners() {
  try {
    this.showStatusModal = true;
    this.loading = true;

    const lab = this.localLabCode || this.labCode;
    const test = this.localTestCode || this.testCode;
    const study = this.studyId;

    const response = await axios.get(
      `${this.baseurl}/management/labreferencerange/getlabreferenceversionbyid`,
      {
        params: {
          labcode: lab,
          testcode: test,
          studyid: study,
        },
        headers: {
          Authorization: `Bearer ${this.token}`,
          "Content-Type": "application/json",
        },
      }
    );

    const data = response.data || {};
    console.log("Full API response for approvers:", data);

    this.approversList = [];
    
    if (data.versions && Array.isArray(data.versions)) {
      const selectedVersion = this.selectedVersion;
      console.log("Selected version for approvers:", selectedVersion);
      
      const selectedVersionData = data.versions.find(v => v.version === selectedVersion);
      
      if (selectedVersionData && selectedVersionData.approval && Array.isArray(selectedVersionData.approval)) {
        this.approversList = selectedVersionData.approval.map(approver => ({
          approvedByUsername: approver.approvedByUsername || '-',
          approvedStatus: approver.approvedStatus || 'Pending',
          approvedByEmail: approver.approvedByEmail
        }));
        
        console.log(`Approvers for version ${selectedVersion}:`, this.approversList);
      } else {
        console.log(`No approvers found for version ${selectedVersion}`);
      }
    } else {
      console.log("No versions data found in API response");
    }
    
  } catch (err) {
    console.error("Error fetching approvers data:", err);
    this.$toast.error("Failed to load approvers data");
  } finally {
    this.loading = false;
  }
},

    async openApprovalModal() {

  if (this.labList.length === 0) {
    alert("Please save at least one reference range before assigning approvers.");
    return;
  }
  
  if (!this.referenceId) {
    if (this.labList[0].id) {
      this.referenceId = this.labList[0].id;
      console.log("Set referenceId from labList:", this.referenceId);
    } else {
      alert("Reference ID is missing. Please save the reference range first.");
      return;
    }
  }
  
  console.log("Opening approval modal with reference ID:", this.referenceId);
  this.documentApprovalModal = true;
  await this.getRoleList();
},

    async closeDocumentApprovalModal() {
      this.roleList = [];
      this.designationList = [];
      this.userList = [];
      this.documentApprovalModal = false;
      this.selectedDueDate = "";
      this.showSave = false;
      await this.setBtnVisibility();
    },

    async getRoleList() {
      try {
        const res = await axios.get(`${this.baseurl}/account-core/roles/rolelist`, {
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
          }
        });
        this.roleList = res.data;
      } catch (err) {
        console.error("Error getting role list:", err);
      }
    },

    async onChange(selected) {
      this.showSave = true;
      this.userobject = [];
      this.userList = [];
      this.isSelectedUser = [];
      this.isRequired = [];

      if (Array.isArray(selected)) {
        for (let roleId of selected) {
          await this.getDesignationUser(roleId);
        }
      } else if (selected) {
        await this.getDesignationUser(selected);
      }
      await this.updateDisabledUsers();
    },

     async getDesignationUser(role) {
        const idtoken = store.getters.getIdToken;
        await axios
          .post(
            `${this.baseurl}/account-core/user/getuserlistbyroles?studyid=${store.getters.getStudyIs}`,
            [`${role}`],
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            if (res.data && res.data.length) {
              const mergedList = [...this.userList, ...res.data];
              this.userList = mergedList
                .filter(
                  (user, index, self) =>
                    index === self.findIndex((u) => u.email === user.email) 
                )
                .sort((a, b) => a.name.localeCompare(b.name));
            }

            this.isRequired = [];
            this.isSelectedUser = [];
            this.isDisabled = [];
            this.userList.forEach((user, index) => {
              this.isRequired[index] = false;
              this.isSelectedUser[index] = false;
              this.isDisabled[index] = false;
              this.loadingSingleSave[index] = false;
            });
            this.getLabReferenceVersion();

          })
          .catch((err) => {
            console.log(err);
          });
   },

    selectall(event) {
      const isChecked = event.target.checked;
      this.isSelectedUser = this.userList.map((u, i) =>
        this.isDisabled[i] ? this.isSelectedUser[i] : isChecked
      );
      this.isRequired = this.userList.map(() => false);
    },

  async singleSaveApprover(user, index) {
  try {
    this.loadingSingleSave[index] = true;


    const payload = {
  
      labCode: this.labCode,
      testCode: this.testCode,
      studyId: this.studyId,
      version: this.selectedVersion,
      actionType: "approval",
      approver: {
        approvalType: "Approval",
        approvalTypeID: "",
        assignedByName: "",
        dueDate: this.selectedDueDate
          ? new Date(this.selectedDueDate).toISOString()
          : null,
        approvedByEmail: user.email || "",
        approvedByUsername: user.userName || "",
        approvedStatus: "Pending",
        isRequired: this.isRequired[index] || false,
        comments: "",
      },
    };

    console.log("Saving approver with reference ID:", this.referenceId);

    await axios.post(
      `${this.baseurl}/management/labreferencerange/singlesaveapproverlab`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${this.token}`,
          "Content-Type": "application/json",
        },
      }
    );

    this.loadingSingleSave[index] = false;
    alert(this.$t("navigations.approver added successfully"));
    await this.listLabTestRanges();
    await this.getLabReferenceVersion();

    await this.setBtnVisibility();
      this.documentApprovalModal = false;
  } catch (err) {
    this.loadingSingleSave[index] = false;
    console.error("Error adding approver:", err);
    alert(
      err.response?.data?.errors?.Id?.[0] ||
      this.$t("navigations.failed to add approver")
    );
  }
},

async multipleSaveApprover() {
  try {
    this.loadingSaveModalBtn = true;

    const selectedUsers = this.userList.filter(
      (u, i) => this.isSelectedUser[i]
    );

    if (!selectedUsers.length) {
      alert("Please select at least one user to save.");
      this.loadingSaveModalBtn = false;
      return;
    }

    const approveList = selectedUsers.map((user, i) => ({
      approvedByName: user.name || "",
      approvedBy: user.userID || "",
      approvedByEmail: user.email || "",
      approvedByUsername: user.userName || "",
      approvedStatus: "Pending",
      approvalType: "Approval",
      approvalTypeID: "",
      approvedDate: new Date().toISOString(),
      assignedByName: "",
      dueDate: this.selectedDueDate
        ? new Date(this.selectedDueDate).toISOString()
        : null,
      isRequired: this.isRequired[i] || false,
      comments: "",
    }));

    const payload = {
      labCode: this.labCode || this.localLabCode || "",
      testCode: this.testCode || this.localTestCode || "",
      studyId: this.studyId,
      version: this.selectedVersion,
      actionType: "approval",
      approveList,
    };

    await axios.post(
      `${this.baseurl}/management/labreferencerange/multiplesaveapproverlab`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${this.token}`,
          "Content-Type": "application/json",
        },
      }
    );

    this.loadingSaveModalBtn = false;
    alert(this.$t("navigations.approvers added successfully"));
   

    await this.listLabTestRanges();
    await this.getLabReferenceVersion();

    await this.setBtnVisibility();
    this.documentApprovalModal = false;
  } catch (err) {
    this.loadingSaveModalBtn = false;
    console.error("Error adding approvers:", err);
    alert(
      err.response?.data?.errors?.Id?.[0] ||
      this.$t("navigations.failed to add approvers")
    );
  }
},




    updateDisabledUsers() {
      if (!this.studyDetails || !this.selectedVersion) return;

      const selectedVersionObj = this.studyDetails.versions.find(
        v => v.version === this.selectedVersion
      );

      if (!selectedVersionObj || !Array.isArray(selectedVersionObj.approval)) {
        this.existingApprovers = [];
        this.isDisabled = this.userList.map(() => false);
        return;
      }
      this.existingApprovers = selectedVersionObj.approval
        .filter(a => a.approvedStatus === "Approved" || a.approvedStatus === "Pending")
        .map(a => a.approvedByEmail);

      this.isDisabled = this.userList.map(u =>
        this.existingApprovers.includes(u.email)
      );
      
      this.isSelectedUser = this.userList.map((u, i) =>
        this.isDisabled[i] ? false : this.isSelectedUser[i]
      );
    },

    async openApproveModal() {
      this.showApproveRejectPopup = true;
    },

    async closeApproveModal() {
      await this.getLabReferenceVersion();
      await this.setBtnVisibility();
      this.showApproveRejectPopup = false;
    },

   getCurrentApprovalStatus() {
  if (!this.labList || this.labList.length === 0) {
    this.currentApprovalStatus = "";
    return;
  }
  const firstRecord = this.labList[0];
  
  if (!firstRecord || !firstRecord.Versions) {
    this.currentApprovalStatus = "";
    return;
  }

  const currentVersionData = firstRecord.Versions.find(
    version => version.Version === this.selectedVersion
  );

  if (!currentVersionData || !currentVersionData.Approval) {
    this.currentApprovalStatus = "";
    return;
  }

  const approvals = currentVersionData.Approval || [];
  
  if (approvals.length === 0) {
    this.currentApprovalStatus = "";
    return;
  }

  const hasPending = approvals.some(approval => approval.ApprovedStatus === "Pending");
  const allApproved = approvals.every(approval => approval.ApprovedStatus === "Approved");

  if (allApproved) {
    this.approvedStatus = "Approved";
  } else if (hasPending) {
    this.approvedStatus = "Pending";
  } else {
    this.approvedStatus = "";
  }
  
  console.log("Current approval status:", this.currentApprovalStatus);
},

  
  getApprovalStatusClass(status) {
    switch (status) {
      case "Approved":
        return "bg-success";
      case "Pending":
        return "bg-warning";
      default:
        return "bg-secondary";
    }
  },
  getApprovalStatusText(status) {
    switch (status) {
      case "Approved":
        return this.$t("navigations.approved") || "Approved";
      case "Pending":
        return this.$t("navigations.pending") || "Pending";
      default:
        return "";
    }
  },
async setBtnVisibility(){
  this.showApproveBtn = false;
 try {
    const lab = this.localLabCode || this.labCode;
    const test = this.localTestCode || this.testCode;
    const study = store.getters.getStudyIs;
    const token = store.getters.getIdToken;
     let useremail =jwt_decode(token).email;

    const response = await axios.get(
      `${this.baseurl}/management/labreferencerange/getlabreferenceversionbyid`,
      {
        params: {
          labcode: lab,
          testcode: test,
          studyid: study,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    const data = response.data || {};
    console.log("Version details:", data);


    console.log("selected version", this.selectedVersion);
    const selectedVersionObj = Array.isArray(data.versions)
      ? data.versions.find(v => v.version === this.selectedVersion)
      : null;

    if (selectedVersionObj) {
      console.log("selectedVersionObj",selectedVersionObj);

      selectedVersionObj.approval.forEach((eachobj)=>{
        if(eachobj.approvedByEmail == useremail && eachobj.approvedStatus != "Approved"){
          this.showApproveBtn = true;
        }
        
      })

     
      


    } 

  } catch (err) {
    console.error("Error fetching lab reference version:", err);
    alert("Failed to fetch lab reference version details");
  }
},
async setBtnVisibilitybackup() {
  console.log("Setting button visibility for version:", this.selectedVersion);
  this.showApproveBtn = true;

  try {
    if (!this.labList || this.labList.length === 0) {
      console.log("No lab list data available");
      return;
    }

    const firstRecord = this.labList[0];
    
    if (!firstRecord) {
      console.log("No record data available");
      return;
    }

    if (!firstRecord.Versions || !Array.isArray(firstRecord.Versions)) {
      console.log("No Versions array found in record");
      this.getCurrentApprovalStatus();
      return;
    }

    const currentVersionData = firstRecord.Versions.find(
      version => version.Version === this.selectedVersion
    );

    if (!currentVersionData) {
      console.log("No version data found for version:", this.selectedVersion);
      this.getCurrentApprovalStatus();
      return;
    }

    console.log("Current version data:", currentVersionData);

 
    const approvals = currentVersionData.Approval || [];
    console.log("Approvals found:", approvals);

    this.getCurrentApprovalStatus();


    if (Array.isArray(approvals) && approvals.length > 0 && this.user && this.user.email) {
      const userPending = approvals.some(
        approval => approval.ApprovedByEmail === this.user.email && 
                   approval.ApprovedStatus === "Pending"
      );
      
      this.showApproveBtn = userPending;
      console.log("User has pending approval:", userPending);
    } else {
      this.showApproveBtn = false;
      console.log("No matching pending approvals found");
    }

    console.log("Final - Show Approve Button:", this.showApproveBtn);

  } catch (err) {
    console.error("Error in setBtnVisibility:", err);
    this.showApproveBtn = false;
    this.getCurrentApprovalStatus();
  }
},
  },
};